import React, {useEffect, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import {Button, DatePicker, Divider, Radio, Space, TimePicker} from 'antd';
import {ArrowLeftOutlined} from "@ant-design/icons";
import {APP_PREFIX_PATH} from "../../../configs/AppConfig";
import {getDates} from "../../../utils/estimated";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useDispatch, useSelector} from "react-redux";
import {getStoreTiming} from 'redux/actions';
import moment from 'moment';
import './estimated.css';

const { RangePicker } = TimePicker;

function EstimatedTime() {
    const {theme:{direction}, fetchedData: {timings, storeData}} = useSelector(state => state);
    const localTime = JSON.parse(localStorage.getItem('fulfillment-time'));
    const history = useHistory()
    const dispatch = useDispatch()
    const dates = getDates(storeData?.scheduleLimit)
    const currentDate = new Date(Date.now());
    
    const [value, setValue] = useState('Scheduled Order');
    const [time, setTime] = useState(JSON.stringify({}));
    const [day, setDay] = useState(dates[0]);
    const [customDate, setCustomDate] = useState(currentDate);
    const [customTime, setCustomTime] = useState([currentDate, currentDate]);

    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
        dispatch(getStoreTiming());
        setTime(JSON.stringify(timings[0]))
    }, []);

    useEffect(() => {
        setValue(localTime ? localTime.type : 'As Soon as Possible');
        setTime(localTime?.time?.openingTime ? JSON.stringify(localTime?.time) : JSON.stringify(timings[0]));
        setDay(localTime?.day ? localTime?.day : dates[0]);
        if(localTime?.type === 'Custom Delivery Time'){
            setCustomDate(new Date(localTime?.day?.customDate))
            setCustomTime([new Date(localTime?.time?.customTime[0]), new Date(localTime?.time?.closing)])
        }
    }, [timings]);

    const setFulfillment = () => {
        if (localStorage.getItem('location')) {
            history.push('review-cart');
        }
        else if (localStorage.getItem('select-product-id') || localStorage.getItem('fulfillment-time')===null){
            window.history.go(-2)
            localStorage.removeItem('select-product-id');
        }
        else{
            window.history.go(-1)
        }
        localStorage.setItem('fulfillment-time', JSON.stringify({
            type: value,
            day, 
            time: JSON.parse(time)
        }));
    }

    // const handleChangeDate = (e) => {
    //     setCustomDate(new Date(e));
    //     setDay({day: weeks[e._d.getDay()], date: `${months[e._d.getMonth()]} ${e._d.getDate()}`, customDate:e._d})
    // }
    // const handleChangeTime = (e) => {
    //     setCustomTime([e[0]._d, e[1]._d]);
    //     setTime(JSON.stringify({
    //         openingTime: e[0]._d.toLocaleTimeString('it-IT'),
    //         closingTime: e[1]._d.toLocaleTimeString('it-IT'), 
    //         closing:e[1]._d,
    //         customTime
    //     }));
    // }

    function hexToRGB(hex, alpha) {
        var r = parseInt(hex?.slice(1, 3), 16),
            g = parseInt(hex?.slice(3, 5), 16),
            b = parseInt(hex?.slice(5, 7), 16);
    
        if (alpha) {
            return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        } else {
            return "rgb(" + r + ", " + g + ", " + b + ")";
        }
    }

    useEffect(()=>{
        document.documentElement.style.setProperty('--primaryColorWithAlpha', hexToRGB?.(storeData?.primaryColor, 0.2));
    }, [storeData?.primaryColor])

    return (
        <div className="d-flex flex-column h-100 position-relative">
            <div className="pt-3 mb-3 pb-2 border-bottom">
                <h3
                    className='order-mode__prev border-0 text-center'>
                    Delivery Time
                    <ArrowLeftOutlined onClick={() => {window.history.back()}} rotate={direction === DIR_RTL ? 180 : 0}/>
                </h3>
            </div>
            <div className="px-3 pb-3">
                <div className="mb-3 estimated-top">
                    <Radio.Group buttonStyle='solid' onChange={e => {
                        setValue(e.target.value)
                        if (e.target.value === 'Scheduled Order'){
                            setTime(localTime?.type===e.target.value ? JSON.stringify(localTime?.time) : JSON.stringify(timings[0]));
                            setDay(localTime?.type===e.target.value ? localTime?.day : dates[0]);
                        }else if (e.target.value==='As Soon as Possible'){
                            setTime(JSON.stringify(timings[0]))
                            setDay(dates[0])
                            // setTime(JSON.stringify({
                            //     openingTime: currentDate.getHours()+' '+currentDate.getMinutes()+' '+currentDate.getSeconds(),
                            //     closingTime: currentDate.getHours()+' '+currentDate.getMinutes()+' '+currentDate.getSeconds(),
                            // }))
                        }else{
                            // setDay({day: weeks[customDate.getDay()], date: `${months[customDate.getMonth()]} ${customDate.getDate()}`, customDate})
                            // setTime(JSON.stringify({
                            //     openingTime: customTime[0].toLocaleTimeString('it-IT'),
                            //     closingTime: customTime[1].toLocaleTimeString('it-IT'), 
                            //     closing:customTime[1],
                            //     customTime
                            // }));
                        }
                    }} value={value}>
                        <Space direction="vertical">
                            {storeData?.orderNow && <Radio 
                                name='pickup-top'
                                className='estimated-top__radio font-size-md'
                                disabled={false} value={"As Soon as Possible"}
                            >
                                As Soon as Possible
                            </Radio>}
                            {storeData?.scheduleDelivery && <Radio 
                                name='pickup-top' 
                                disabled={storeData?.scheduleLimit<=0} 
                                className='estimated-top__radio font-size-md'
                                value={"Scheduled Order"}
                            >
                                Scheduled Order
                            </Radio>}
                            {storeData?.enableCustomDelivery && <Radio 
                                name='pickup-top' 
                                disabled={storeData?.scheduleLimit<=0} 
                                className='estimated-top__radio font-size-md'
                                value={"Custom Delivery - " + storeData?.customDeliveryText}
                            >
                                {storeData?.customDeliveryText}
                            </Radio>}
                        </Space>
                    </Radio.Group>
                </div>
                <div style={{position: 'sticky', top: '0', zIndex: '2', backgroundColor: 'white'}}>
                    {value==='Scheduled Order' && storeData?.scheduleDelivery && <div className='overflow-auto mb-3 text-center d-flex border-top'>
                        {dates.map( (item) =>
                            <div onClick={()=>setDay(item)} key={item.date} className={`mr-2 estimated__date ${day.date===item.date && 'selected__estimated__date'}`}>
                                <div className='mb-0 font-16'>{item.date}</div>
                                <h4 className='m-0'>{item?.index === 0 ? 'Today' : ( item?.index === 1 ? 'Tomorrow' : item.day)}</h4>
                            </div>
                        )}
                    </div>}
                </div>
                <div>
                    {value==='Scheduled Order' && storeData?.scheduleLimit>0 && storeData?.scheduleDelivery && <Radio.Group buttonStyle='solid' onChange={e => setTime(e.target.value)} value={time} >
                        <Space direction="vertical">
                            {timings.map( item => {
                                if (item?.day?.toLowerCase() == day?.day?.toLowerCase() || item?.day?.toLowerCase() === 'everyday'){
                                    return <Radio
                                        name='pickup-time'
                                        className='estimated-top__radio font-size-md'
                                        key={item?.id}
                                        value={JSON.stringify(item)}
                                    >
                                        {item?.openingTime + ' - ' + item?.closingTime}
                                    </Radio>
                                }
                            })}
                        </Space>
                    </Radio.Group>}
                </div>
                {/* {value==='Custom Delivery Time' && <div>
                    <Divider/>
                    <h4 className='my-2 text-black'>Select Date</h4>
                    <DatePicker onChange={handleChangeDate} value={moment(customDate)}/>
                    <h4 className='my-2 text-black'>Select Time</h4>
                    <RangePicker onChange={handleChangeTime} value={[moment(customTime[0]), moment(customTime[1])]}/>
                </div>} */}
            </div> 
            <div className='setTimeBtnContainer px-3'>
                {/* <div 
                to={APP_PREFIX_PATH + (localStorage.getItem('select-product-id') ? `/products/${localStorage.getItem('select-product-id')}` : '/menu')}
                > */}
                    <Button onClick={setFulfillment} className='w-100 setTimeBtn primaryColor'>
                        Set time ・ {value === 'As Soon as Possible' ? value : value?.includes('Custom') ? value.slice(18) : 
                         `${day?.date} ${JSON.parse(time)?.openingTime} - ${JSON.parse(time)?.closingTime}`}
                    </Button>
                {/* </div> */}
            </div>
        </div>
    );
}

export default EstimatedTime;